import { get } from 'lodash'
import { default as deserialize, formatMeta } from 'app/utils/deserialize'
import { fetch, create, remove, update } from 'app/utils/data'
import FormErrors from 'app/utils/form_errors'

// `null` (rather than 0) lets the team-page UI distinguish "haven't fetched
// yet" from "the customer's effective seat cap is 0" (e.g. an admin override
// that sets seats to 0). Templates that want to gate on data-loaded should
// check `total !== null`, not the truthiness of `total`.
const DEFAULT_SEATS = { used: null, total: null }

export default {
  namespaced: true,

  state: {
    list: [],
    seats: DEFAULT_SEATS
  },

  getters: {
    all: (state) => state.list,
    seats: (state) => state.seats
  },

  mutations: {
    teamMembersFetched(state, { teamMembers, seats }) {
      state.list = teamMembers
      state.seats = seats
    },

    resetState(state) {
      state.list = []
      state.seats = DEFAULT_SEATS
    }
  },

  actions: {
    async fetchTeamMembers({ commit }) {
      const response = await fetch({ url: '/api/team-members' })

      const teamMembers = await deserialize(response.data)

      const seats = formatMeta(get(response.data, ['meta', 'seats']))

      commit('teamMembersFetched', { teamMembers, seats })

      return teamMembers
    },

    async inviteTeamMember({ dispatch }, { email, role }) {
      try {
        const response = await create({
          url: '/api/team-members',
          type: 'team-member',
          data: { email, role }
        })

        const teamMember = await deserialize(response.data)

        await dispatch('fetchTeamMembers')

        return teamMember
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    },

    async updateTeamMember({ dispatch }, { teamMember, role, password }) {
      try {
        const response = await update({
          url: `/api/team-members/${teamMember.id}`,
          type: 'team-member',
          changes: { role: role },
          record: teamMember,
          meta: { password }
        })

        const updatedTeamMember = await deserialize(response.data)

        await dispatch('fetchTeamMembers')

        return updatedTeamMember
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    },

    async deleteTeamMember({ dispatch }, { teamMember }) {
      try {
        await remove({
          url: `/api/team-members/${teamMember.id}`,
          type: 'team-member'
        })

        await dispatch('fetchTeamMembers')

        // Keep $account.teamSize in sync for the delete-account modal.
        try {
          await dispatch('sessions/fetchCurrentSession', null, { root: true })
        } catch (_e) {
          // Don't fail the team-member delete on a session-refresh error.
        }
      } catch (error) {
        throw new FormErrors(error.response.data.errors)
      }
    }
  }
}
